import tailwindRuntimeConfig from './tailwind-runtime-config.json'

export const { theme } = tailwindRuntimeConfig
